import {Inject, Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {AuthService} from "../shared/services/auth.service";
import {APP_URL, LOGIN_URL} from "../api.token";
import {navigateToLoginPage} from "../shared/utilities/auth.util";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        @Inject(APP_URL) private appUrl: string,
        @Inject(LOGIN_URL) private loginUrl: string,
        private router: Router,
        private cookieService: CookieService,
        private authService: AuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let accessToken: string | null = null;

        const urlParams = new URLSearchParams(window.location.search);
        const urlAccessToken = urlParams.get('access_token');

        if (urlAccessToken) {
            // If access_token is in the URL, save it in a cookie
            document.cookie = `access_token=${urlAccessToken}; path=/; secure`;
            accessToken = urlAccessToken;
        } else {
            // Otherwise, read access_token from the cookie
            const cookies = document.cookie.split('; ');
            const tokenCookie = cookies.find((cookie) => cookie.startsWith('access_token='));
            if (tokenCookie) {
                accessToken = tokenCookie.split('=')[1];
            }
        }


// ********************
//         if (accessToken) {
//             // Add access_token as a query parameter
//             const url = this.router.url;
//             const a = url.includes('/signing/');
//             console.log('url ********************* url')
//
//             const modifiedUrl = new URL(req.url, window.location.origin);
//             modifiedUrl.searchParams.set('access_token', accessToken);
//
//
//             let authReq = req.clone({
//                 url: modifiedUrl.toString(),
//                 setHeaders: {
//                     Authorization: `Bearer ${accessToken}`
//                 }
//             });
//             return next.handle(authReq);
//         }
//         return next.handle(req);
// *********************


        if (accessToken) {
            const modifiedUrl = new URL(req.url, window.location.origin);
            modifiedUrl.searchParams.set('access_token', accessToken);

            req = req.clone({
                url: modifiedUrl.toString(),
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && !this.router.url.includes('/signing/')) {
                    navigateToLoginPage(this.appUrl, this.loginUrl);
                }
                return throwError(() => error);
            })
        );
    }

}
